// auth.js
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const UPDATE_USER = 'UPDATE_USER'

// users.js
export const DELETE_USERS = 'DELETE_USERS'
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'

// evaluations.js
export const FETCH_EVALUATIONS_FAILURE = 'FETCH_EVALUATIONS_FAILURE'
export const FETCH_EVALUATIONS_SUCCESS = 'FETCH_EVALUATIONS_SUCCESS'
// isco.js
export const FETCH_ISCO_FAILURE = 'FETCH_ISCO_FAILURE'
export const FETCH_ISCO_SUCCESS = 'FETCH_ISCO_SUCCESS'

// organizations.js
export const DELETE_ORGANIZATIONS_SUCCESS = 'DELETE_ORGANIZATIONS_SUCCESS'
export const DELETE_ORGANIZATIONS_FAILURE = 'DELETE_ORGANIZATIONS_FAILURE'
export const FETCH_ORGANIZATIONS_FAILURE = 'FETCH_ORGANIZATIONS_FAILURE'
export const FETCH_ORGANIZATIONS_SUCCESS = 'FETCH_ORGANIZATIONS_SUCCESS'

// languages.js
export const FETCH_LANGUAGES_FAILURE = 'FETCH_LANGUAGES_FAILURE'
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS'

// genders.js
export const FETCH_GENDERS_SUCCESS = 'FETCH_GENDERS_SUCCESS'
export const FETCH_GENDERS_FAILURE = 'FETCH_GENDERS_FAILURE'

// nationalities.js
export const FETCH_NATIONALITIES_FAILURE = 'FETCH_NATIONALITIES_FAILURE'
export const FETCH_NATIONALITIES_SUCCESS = 'FETCH_NATIONALITIES_SUCCESS'

// roles.js
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE'
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'

// scholarlevels.js
export const FETCH_SCHOLARLEVELS_SUCCESS = 'FETCH_SCHOLARLEVELS_SUCCESS'
export const FETCH_SCHOLARLEVELS_FAILURE = 'FETCH_SCHOLARLEVELS_FAILURE'

// professionallevels.js
export const FETCH_PROFESSIONALLEVELS_SUCCESS = 'FETCH_PROFESSIONALLEVELS_SUCCESS'
export const FETCH_PROFESSIONALLEVELS_FAILURE = 'FETCH_PROFESSIONALLEVELS_FAILURE'

// satisfactionperceptions.js
export const FETCH_SATISFACTIONPERCEPTIONS_SUCCESS = 'FETCH_SATISFACTIONPERCEPTIONS_SUCCESS'
export const FETCH_SATISFACTIONPERCEPTIONS_FAILURE = 'FETCH_SATISFACTIONPERCEPTIONS_FAILURE'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'



// WEBPACK FOOTER //
// ./resources/js/store/mutation-types.js